"use strict";
/**
 * @module adaptive-expressions
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const expressionProperties_1 = require("../expressionProperties");
class EnumExpressionConverter {
    constructor(enumValue) {
        this._enumValue = enumValue;
    }
    convert(value) {
        if (typeof value == 'string') {
            if (this._enumValue.hasOwnProperty(value)) {
                return new expressionProperties_1.EnumExpression(this._enumValue[value]);
            }
            return new expressionProperties_1.EnumExpression(`=${value}`);
        }
        return new expressionProperties_1.EnumExpression(value);
    }
}
exports.EnumExpressionConverter = EnumExpressionConverter;
//# sourceMappingURL=enumExpressionConverter.js.map